/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RealEstateDto } from './RealEstateDto';
import {
    RealEstateDtoFromJSON,
    RealEstateDtoFromJSONTyped,
    RealEstateDtoToJSON,
    RealEstateDtoToJSONTyped,
} from './RealEstateDto';

/**
 * 
 * @export
 * @interface ReadListRealEstateDto
 */
export interface ReadListRealEstateDto {
    /**
     * List of real estate properties
     * @type {Array<RealEstateDto>}
     * @memberof ReadListRealEstateDto
     */
    realEstates: Array<RealEstateDto>;
}

/**
 * Check if a given object implements the ReadListRealEstateDto interface.
 */
export function instanceOfReadListRealEstateDto(value: object): value is ReadListRealEstateDto {
    if (!('realEstates' in value) || value['realEstates'] === undefined) return false;
    return true;
}

export function ReadListRealEstateDtoFromJSON(json: any): ReadListRealEstateDto {
    return ReadListRealEstateDtoFromJSONTyped(json, false);
}

export function ReadListRealEstateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadListRealEstateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'realEstates': ((json['realEstates'] as Array<any>).map(RealEstateDtoFromJSON)),
    };
}

export function ReadListRealEstateDtoToJSON(json: any): ReadListRealEstateDto {
    return ReadListRealEstateDtoToJSONTyped(json, false);
}

export function ReadListRealEstateDtoToJSONTyped(value?: ReadListRealEstateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realEstates': ((value['realEstates'] as Array<any>).map(RealEstateDtoToJSON)),
    };
}

